var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.55 32.55"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".square_svg__cls-1{fill:none;stroke:#333;stroke-miterlimit:10;stroke-width:1.8px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "square_svg__cls-1",
    d: "M11.42 6.13l4.85-4.86 4.86 4.86M6.13 21.13l-4.86-4.86 4.86-4.85M21.13 26.42l-4.86 4.85-4.85-4.85M26.42 11.42l4.85 4.85-4.85 4.86"
  })))));
}
export default SvgSquare;